module.exports = __webpack_public_path__ + "static/media/29EUNOG2.9dbb02d2.jpg";